import React, { useState, useEffect } from 'react';
import { updateFooterConfig, getFooterConfig } from '../firebase/services';
import toast from 'react-hot-toast';
import './Admin.css';

export default function ManageFooter() {
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    address: '',
    facebook: '',
    instagram: '',
    tiktok: '',
    whatsapp: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadFooterConfig();
  }, []);

  const loadFooterConfig = async () => {
    const config = await getFooterConfig();
    if (config) {
      setFormData(config);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateFooterConfig(formData);
      toast.success("Footer updated successfully!");
    } catch (error) {
      toast.error("Error updating footer: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Manage Footer</h2>
        <p>Update contact info and social links</p>
      </div>

      <div className="admin-card">
        <div className="card-header">
          <h3><ion-icon name="call-outline"></ion-icon> Contact Information</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="input-group">
              <label>Support Email</label>
              <input 
                className="custom-input" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                placeholder="support@vetcare.com"
              />
            </div>
            <div className="input-group">
              <label>Phone Number</label>
              <input 
                className="custom-input" 
                name="phone" 
                value={formData.phone} 
                onChange={handleChange} 
                placeholder="015 5355 5330"
              />
            </div>
          </div>

          <div className="input-group">
            <label>Address</label>
            <textarea 
              className="custom-textarea" 
              name="address" 
              value={formData.address} 
              onChange={handleChange} 
              placeholder="Full address..."
              style={{minHeight: '80px'}}
            />
          </div>

          <div className="card-header" style={{marginTop: '30px', marginBottom: '20px'}}>
            <h3><ion-icon name="share-social-outline"></ion-icon> Social Media Links</h3>
          </div>

          <div className="form-grid">
            <div className="input-group">
              <label>Facebook URL</label>
              <input 
                className="custom-input" 
                name="facebook" 
                value={formData.facebook} 
                onChange={handleChange} 
                placeholder="https://facebook.com/..."
              />
            </div>
            <div className="input-group">
              <label>Instagram URL</label>
              <input 
                className="custom-input" 
                name="instagram" 
                value={formData.instagram} 
                onChange={handleChange} 
                placeholder="https://instagram.com/..."
              />
            </div>
            <div className="input-group">
              <label>TikTok URL</label>
              <input 
                className="custom-input" 
                name="tiktok" 
                value={formData.tiktok} 
                onChange={handleChange} 
                placeholder="https://tiktok.com/..."
              />
            </div>
            <div className="input-group">
              <label>WhatsApp URL</label>
              <input 
                className="custom-input" 
                name="whatsapp" 
                value={formData.whatsapp} 
                onChange={handleChange} 
                placeholder="https://wa.me/..."
              />
            </div>
          </div>

          <button type="submit" className="btn-primary" disabled={loading} style={{marginTop: '20px'}}>
            {loading ? 'Saving...' : (
              <>
                <ion-icon name="save-outline"></ion-icon> Update Footer
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
